import { StyleSheet } from 'aphrodite';
import { dataOriginDark } from '../../../../web/containers/DataOriginContainer/styles';
import {
	actionItemTintColor,
	brandPrimary,
	brandPrimaryHover,
	brandPrimaryText,
	kitTintColor,
	label,
	titles,
} from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	accountUserRow: {
		height: 96,
	},
	avatar: {
		boxSizing: 'border-box',
		fontSize: 14,
		height: 35,
		width: 35,
	},
	avatarGreen: {
		...CssSelectors.allChildren({
			background: actionItemTintColor,
		}),
	},
	avatarHeader: {
		maxWidth: 30,
		width: 20,
	},
	avatarOrange: {
		...CssSelectors.allChildren({
			background: kitTintColor,
		}),
	},
	avatarRed: {
		...CssSelectors.allChildren({
			background: '#C22639',
		}),
	},
	avatarYellow: {
		...CssSelectors.allChildren({
			background: '#F0E832',
		}),
	},
	connectSuccess: {
		paddingLeft: 5,
		paddingTop: 5,
	},
	employeeListName: {
		minWidth: 300,
		padding: '0 20px',
		width: '25%',
	},
	importedLinkedInLink: {
		color: brandPrimaryText,
		cursor: 'pointer',
		margin: '0px 3px',
		textDecoration: 'underline',
	},
	mainContactIcon: {
		alignItems: 'center',
		display: 'inline-flex',
	},
	menuColumn: {
		paddingTop: 15,
		verticalAlign: 'top',
	},
	popoverContent: {
		padding: '14px 20px',
	},
	popoverStyle: {
		background: '#FCEDDF',
		border: `1px solid ${dataOriginDark}`,
		color: label,
		fontSize: 14,
	},
	spinnerListItem: {
		alignItems: 'center',
		display: 'flex',
		minHeight: 75,
		padding: '15px 0 15px 0',
	},
	targetContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	targetType: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				height: 16,
				marginRight: 6,
			},
			'img'
		),
	},
	userCol: {
		fontWeight: 600,
	},
	userEmail: {
		color: titles,
		fontSize: 12,
		fontWeight: 'normal',
	},
	userMilestone: {
		paddingBottom: 20,
		paddingTop: 10,
		textAlign: 'center',
	},
	userName: {
		color: brandPrimaryText,
		fontSize: 18,
		display: 'block',
		transition: 'all ease 300ms',
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
			color: brandPrimaryHover,
		},
		':active': {
			color: brandPrimary,
		},
	},
	loading: {
		display: 'inline-block',
	},
});
